import { Tbody } from './Tbody';
import { Thead } from './Thead';
import { Tr } from './Tr';
import { Th } from './Th';
import { Td } from './Td';
import { Table as ChakraTable } from '@chakra-ui/react';
import { TdSkeleton } from './Skeleton';

const Table = ({ colorScheme = 'gray', variant = 'striped', children, ...props }) => (
  <ChakraTable colorScheme={colorScheme} variant={variant} {...props}>
    {children}
  </ChakraTable>
);

export { Tbody, Thead, Tr, Th, Td, Table, TdSkeleton };
